import { put } from './api'
import { ConfirmConsumerOrderRequest, RetrieveConsumerOrderRequest } from '../../model'

export const retrieveOrder = async (params?: RetrieveConsumerOrderRequest): Promise<any> => {
    const { data } = await put('/consumer/retrieve-order', {
        data: params
    })
    return data
    /**
     * Temporary mock data for testing purposes
     * This should be replaced with the actual API call when available.
     */
    // return Promise.resolve({
    //     order: {
    //         address: {
    //             zipcode: '2222AA',
    //             houseNumber: 1,
    //             extension: 'a',
    //             street: 'string',
    //             city: 'string',
    //             surface: 10
    //         },
    //         totalAmount: 0,
    //         lines: [
    //             {
    //                 name: 'Woonfotografie',
    //                 icon: 'fa-camera'
    //             }
    //         ]
    //     },
    //     invoiceDetails: {
    //         name: 'Example name',
    //         street: 'Example street',
    //         houseNumber: '1',
    //         zipcode: '1823WB',
    //         city: 'Alkmaar',
    //         emailAddress: 'info@example.com'
    //     }
    // })
}

export const confirmOrder = async (params: ConfirmConsumerOrderRequest): Promise<any> => {
    const { data } = await put(`/consumer/confirm-order`, {
        data: params
    })
    return data
}
